import { render, staticRenderFns } from "./outside-fixedcode.vue?vue&type=template&id=85f4a2ba&scoped=true&"
import script from "./outside-fixedcode.vue?vue&type=script&lang=js&"
export * from "./outside-fixedcode.vue?vue&type=script&lang=js&"
import style0 from "./outside-fixedcode.vue?vue&type=style&index=0&id=85f4a2ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f4a2ba",
  null
  
)

export default component.exports